@if (loader.state().visible) {
  <div
    class="loader-overlay"
    role="progressbar"
    [attr.aria-valuenow]="loader.state().deterministic ? loader.state().progress : null"
    [attr.aria-valuemin]="loader.state().deterministic ? 0 : null"
    [attr.aria-valuemax]="loader.state().deterministic ? 100 : null"
  >
    <div class="loader-content">
      @if (loader.state().deterministic) {
        <div class="progress-loader">
          <div class="progress-loader__bar" [style.width.%]="loader.state().progress"></div>
        </div>

        <span class="loader-progress"> {{ loader.state().progress }}% </span>
      } @else {
        <div class="spinner" aria-hidden="true">
          <span></span>
          <span></span>
          <span></span>
        </div>
      }

      @if (loader.state().message) {
        <span class="loader-message">
          {{ loader.state().message }}
        </span>
      }
    </div>
  </div>
}
